<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
         <h2><span class="fontIcon fontIconBig"><font-awesome-icon :icon="['fal', 'file-alt']"></font-awesome-icon></span> Ordrar</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <button class="btn btn-primary">Skapa ny</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="orderStatusWrapper">
          <ul>
            <li><a href="#">Ohanterad</a></li>
            <li><a href="#">Preliminärt</a></li>
            <li><a href="#">Bekräftad</a></li>
            <li><a href="#">Pågående</a></li>
            <li><a href="#">Ändrad</a></li>
            <li><a href="#">Avslutad</a></li>
            <li><a href="#">Fakturerad</a></li>
            <li><a href="#">Makulerad</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table-hover orderList" v-if="items">
            <thead>
              <tr>
                <th>Status</th>
                <th>Datum</th>
                <th>Order</th>
                <th>Kund</th>
                <th>Produkt</th>
                <th>Kvantitet</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id" :class="item.classStatus">
                <td>{{item.status}}</td>
                <td>
                  <router-link :to="{ name: 'Order', params: { id: item.orderId } }">
                    {{ item.orderLastDate }}
                  </router-link>
                </td>
                <td>{{ item.orderNr }}</td>
                <td>{{ item.customer }}</td>
                <td>{{ item.productName }}</td>
                <td>{{ item.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderListOld',
  data () {
    return {
      msg: 'Orderlista',
      items: [
        {
          typ: 'Feralco artikel',
          orderLastDate: '2019-03-16',
          orderId: '1',
          orderNr: '12345',
          customer: 'Feralco',
          productName: 'Produktnamn',
          comment: 'Här kommer kommentaren',
          quantity: '42',
          status: 'Pågående',
          classStatus: 'pagaande'
        },
        {
          typ: 'Feralco intern',
          orderLastDate: '2019-03-16',
          orderId: '2',
          orderNr: '67891',
          customer: 'Hydro Building',
          productName: 'Produktnamn 2',
          comment: 'Här kommer kommentaren',
          quantity: '42',
          status: 'Klar för fakturering',
          classStatus: 'fakturering'
        },
        {
          typ: 'Timkörning',
          orderLastDate: '2019-03-16',
          orderId: '3',
          orderNr: '678922',
          customer: 'Hydro Building',
          productName: 'Produktnamn 3',
          comment: 'Här kommer kommentaren',
          quantity: '42',
          status: 'Pågående',
          classStatus: 'pagaande'
        },
        {
          typ: 'Timkörning',
          orderLastDate: '2019-03-16',
          orderId: '3',
          orderNr: '678922',
          customer: 'Hydro Building',
          productName: 'Produktnamn 3',
          comment: 'Här kommer kommentaren',
          quantity: '42',
          status: 'Avslutad',
          classStatus: 'avslutad'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrderListOld.vue